// ----------------------------------------------------------------------
// <copyright file="Izenda.PrintablePage.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!(function () {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var PrintConstants = require('logic/data/Izenda.PrintConstants');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var classnames = require('classnames');
  var ReportHeader = require('modules/ReportDesigner/Fields/Izenda.ReportHeader');
  var ReportFooter = require('modules/ReportDesigner/Fields/Izenda.ReportFooter');
  var ReportBodyViewer = require('share/components/views/Izenda.ReportBodyViewer');
  var PrintingUtils = require('share/utils/Izenda.PrintingUtils');
  var ScrollBox = require('share/components/controls/Izenda.ScrollBox');

  var PrintablePage = React.createClass({
    getDefaultProps: function () {
      return {
        viewMode: true
      };
    },
    render: function () {
      var props = this.props;
      function getSizeUi(value) {
        return value < PrintConstants.MIN_SIZE_UI_SETTING ? PrintConstants.MIN_SIZE_UI_SETTING : value;
      }

      var pageSizeKey = props.pageSizeKey || PrintConstants.DEFAULT_PAGE_SIZE_KEY;
      var pageMargins = {
        top: getSizeUi(props.top),
        right: getSizeUi(props.right),
        bottom: getSizeUi(props.bottom),
        left: getSizeUi(props.left)
      };

      var contentSizeInInches = PrintConstants.getBodyContentSizeInInches(
        pageSizeKey,
        pageMargins,
        props.header,
        props.footer,
        props.orientation);

      var scaleX = props.exportFormatSetting.scaleX;
      var lineSize = PrintConstants.MIN_SIZE_UI_SETTING/2;

      var pageSize = PrintConstants.getPageSize(props.pageSizeKey, props.orientation);
      var col0WidthInPercent = (pageMargins.left * 100) / pageSize.widthInInches;
      var col1WidthInPercent = (lineSize * 100) / pageSize.widthInInches;
      var col3WidthInPercent = (lineSize * 100) / pageSize.widthInInches;
      var col4WidthInPercent = (pageMargins.right * 100) / pageSize.widthInInches;
      var col2WidthInPercent = 100 - Math.round((col0WidthInPercent + col1WidthInPercent + col3WidthInPercent + col4WidthInPercent));

      var row0HeightInPercent = (pageMargins.top * 100) / pageSize.heightInInches;
      var row1HeightInPercent = (lineSize * 100) / pageSize.widthInInches;
      var row3HeightInPercent = (lineSize * 100) / pageSize.widthInInches;
      var row4HeightInPercent = (pageMargins.bottom * 100) / pageSize.heightInInches;
      var row2HeightInPercent = 100 - Math.round((row0HeightInPercent + row1HeightInPercent + row3HeightInPercent + row4HeightInPercent));

      var columnStyles = [
        { // col 00
          width: PrintConstants.formatCSSValueInPercent(col0WidthInPercent)
        }, { // col 01
          width: PrintConstants.formatCSSValueInPercent(col1WidthInPercent)
        }, { // col 02
          width: PrintConstants.formatCSSValueInPercent(col2WidthInPercent)
        }, { // col 03
          width: PrintConstants.formatCSSValueInPercent(col3WidthInPercent)
        }, { // col 04
          width: PrintConstants.formatCSSValueInPercent(col4WidthInPercent)
        }];

      var rowStyles = [
        { // row 00
          height: PrintConstants.formatCSSValueInPercent(row0HeightInPercent)
        }, { // row 01
          height: PrintConstants.formatCSSValueInPercent(row1HeightInPercent)
        }, { // row 02
          height: PrintConstants.formatCSSValueInPercent(row2HeightInPercent)
        }, { // row 03
          height: PrintConstants.formatCSSValueInPercent(row3HeightInPercent)
        }, { // row 04
          height: PrintConstants.formatCSSValueInPercent(row4HeightInPercent)
        }];

      return (
        <GridLayout className='izenda-PrintablePage u_fullSize'>
          {/* row 0 */}
          <GridLayout.Row className='u_noMarginAll u_noPaddingAll' style={{ height: rowStyles[0].height }}>
            <GridLayout.Col cols='1' className='u_noMarginAll u_noPaddingAll' style={{ width: columnStyles[0].width }}>{/* empty */}</GridLayout.Col>
            <GridLayout.Col cols='1' className='non-width u_noMarginAll u_noPaddingAll u_fullHeight'>{/* empty */}</GridLayout.Col>
            <GridLayout.Col cols='8' className='u_noMarginAll u_noPaddingAll' style={{ width: columnStyles[2].width }}>{/* empty */}</GridLayout.Col>
            <GridLayout.Col cols='1' className='non-width u_noMarginAll u_noPaddingAll u_fullHeight'>{/* empty */}</GridLayout.Col>
            <GridLayout.Col cols='1' className='u_noMarginAll u_noPaddingAll' style={{ width: columnStyles[4].width }}>{/* empty */}</GridLayout.Col>
          </GridLayout.Row>
          {/* row 1 */}
          <GridLayout.Row className='non-height u_noMarginAll u_noPaddingAll u_fullWidth u_table'>
            <GridLayout.Col cols='1' className='u_noMarginAll u_noPaddingAll' style={{ width: columnStyles[0].width }}>{/* empty */}</GridLayout.Col>
            <GridLayout.Col cols='1' className='non-width u_noMarginAll u_noPaddingAll u_fullHeight'>{/* empty */}</GridLayout.Col>
            <GridLayout.Col cols='8' className='y-line u_noMarginAll u_noPaddingAll' style={{ width: columnStyles[2].width }}>{/* empty */}</GridLayout.Col>
            <GridLayout.Col cols='1' className='non-width u_noMarginAll u_noPaddingAll u_fullHeight'>{/* empty */}</GridLayout.Col>
            <GridLayout.Col cols='1' className='u_noMarginAll u_noPaddingAll' style={{ width: columnStyles[4].width }}>{/* empty */}</GridLayout.Col>
          </GridLayout.Row>
          {/* row 2 */}
          <GridLayout.Row className='u_noMarginAll u_noPaddingAll' style={{ height: rowStyles[2].height }}>
            <GridLayout.Col cols='1' className='u_noMarginAll u_noPaddingAll' style={{ width: columnStyles[0].width }}>{/* empty */}</GridLayout.Col>
            <GridLayout.Col cols='1' className='x-line non-width u_noMarginAll u_noPaddingAll u_fullHeight'>{/* empty */}</GridLayout.Col>
            <GridLayout.Col cols='8' className='u_noMarginAll u_noPaddingAll u_fullSize' style={{ width: columnStyles[2].width }}>
              {/* content here */}
              {renderContent()}
            </GridLayout.Col>
            <GridLayout.Col cols='1' className='x-line non-width u_noMarginAll u_noPaddingAll u_fullHeight'>{/* empty */}</GridLayout.Col>
            <GridLayout.Col cols='1' className='u_noMarginAll u_noPaddingAll' style={{ width: columnStyles[4].width }}>{/* empty */}</GridLayout.Col>
          </GridLayout.Row>
          {/* row 3 */}
          <GridLayout.Row className='non-height u_noMarginAll u_noPaddingAll u_fullWidth u_table'>
            <GridLayout.Col cols='1' className='u_noMarginAll u_noPaddingAll' style={{ width: columnStyles[0].width }}>{/* empty */}</GridLayout.Col>
            <GridLayout.Col cols='1' className='non-width u_noMarginAll u_noPaddingAll u_fullHeight'>{/* empty */}</GridLayout.Col>
            <GridLayout.Col cols='8' className='y-line u_noMarginAll u_noPaddingAll' style={{ width: columnStyles[2].width }}>{/* empty */}</GridLayout.Col>
            <GridLayout.Col cols='1' className='non-width u_noMarginAll u_noPaddingAll u_fullHeight'>{/* empty */}</GridLayout.Col>
            <GridLayout.Col cols='1' className='u_noMarginAll u_noPaddingAll' style={{ width: columnStyles[4].width }}>{/* empty */}</GridLayout.Col>
          </GridLayout.Row>
          {/* row 4 */}
          <GridLayout.Row className='u_noMarginAll u_noPaddingAll' style={{ height: rowStyles[4].height }}>
            <GridLayout.Col cols='1' className='u_noMarginAll u_noPaddingAll' style={{ width: columnStyles[0].width }}>{/* empty */}</GridLayout.Col>
            <GridLayout.Col cols='1' className='non-width u_noMarginAll u_noPaddingAll u_fullHeight'>{/* empty */}</GridLayout.Col>
            <GridLayout.Col cols='8' className='u_noMarginAll u_noPaddingAll' style={{ width: columnStyles[2].width }}>{/* empty */}</GridLayout.Col>
            <GridLayout.Col cols='1' className='non-width u_noMarginAll u_noPaddingAll u_fullHeight'>{/* empty */}</GridLayout.Col>
            <GridLayout.Col cols='1' className='u_noMarginAll u_noPaddingAll' style={{ width: columnStyles[4].width }}>{/* empty */}</GridLayout.Col>
          </GridLayout.Row>
        </GridLayout>
      );

      function renderContent() {
        var contentContainerHeightInInches = contentSizeInInches.heightOfContentInInches + props.header + props.footer;
        var headerHeightInPercent = Math.round(props.header * 100 / contentContainerHeightInInches);
        var footerHeightInPercent = Math.round(props.footer * 100 / contentContainerHeightInInches);
        var contentHeightInPercent = 100 - (headerHeightInPercent + footerHeightInPercent);

        var contentContainerClassName = classnames('u_noMarginAll u_noPaddingAll u_fullSize');

        var contentClassName = classnames('u_tableCell', {
          'u_alignTop': !props.vertically,
          'u_alignMiddle': props.vertically
        });

        var headerContainerClassName = classnames('u_noMarginAll u_noPaddingAll u_fullSize u_table');

        var headerClassName = classnames('u_tableCell', {
          'u_alignTop': !props.vertically,
          'u_alignMiddle': props.vertically
        });

        var footerContainerClassName = classnames('u_noMarginAll u_noPaddingAll u_fullSize u_table');

        var footerClassName = classnames('u_tableCell', {
          'u_alignTop': !props.vertically,
          'u_alignMiddle': props.vertically
        });
        var viewMode = props.viewMode;

        return (
          <GridLayout className='u_fullSize'>
            <GridLayout.Row className='u_noMarginAll u_noPaddingAll u_overflowHidden'
              style={{ height: PrintConstants.formatCSSValueInPercent(headerHeightInPercent) }}>
              <GridLayout.Col className={headerContainerClassName}>
                <ReportHeader className={headerClassName}
                  setting
                  viewMode
                  horizontalAlign={props.horizontally}
                  replaceSystemVariable={PrintingUtils.replaceSystemVariable}
                  store={props.store} />
              </GridLayout.Col>
            </GridLayout.Row>
            <GridLayout.Row className='body-content u_noMarginAll u_noPaddingAll'
              style={{ height: PrintConstants.formatCSSValueInPercent(contentHeightInPercent) }}>
              <ScrollBox>
                <GridLayout.Col className={contentContainerClassName} style={PrintingUtils.buildScaleStyle(scaleX)}>
                  <ReportBodyViewer
                    className={contentClassName}
                    id={props.store.reportId}
                    exportFormatSetting={props.exportFormatSetting}
                    printingMode
                    setting 
                    viewMode={viewMode}/>
                </GridLayout.Col>
              </ScrollBox>
            </GridLayout.Row>
            <GridLayout.Row className='footer-content u_noMarginAll u_noPaddingAll u_overflowHidden'
              style={{ height: PrintConstants.formatCSSValueInPercent(footerHeightInPercent) }}>
              <GridLayout.Col className={footerContainerClassName}>
                <ReportFooter className={footerClassName}
                  setting
                  viewMode
                  horizontalAlign={props.horizontally}
                  store={props.store} />
              </GridLayout.Col>
            </GridLayout.Row>
          </GridLayout>
        );
      }
    }
  });

  module.exports = connect({ toClass: true })(PrintablePage);
} ());



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.PrintablePage.jsx